export { colorPrimitives } from "./colorPrimitives";
export type { ColorHue, ColorShade } from "./colorPrimitives";

export {
  // Slot-first source of truth — prefer `theme.vars.palette.rmh.*` in
  // packages/ds, but raw scheme objects are available for theme construction.
  lightSemantic,
  darkSemantic,
  semantic,
  // Mode-first compat layer — kept for `apps/*` callers until they migrate.
  colorSemantic,
  text,
  icon,
  border,
  paper,
  paperElevation,
  stateBackground,
  stateBorder,
  nativeColor,
  focus,
} from "./colorSemantic";
export type {
  SemanticPalette,
  ModePair,
  InteractiveTriplet,
} from "./colorSemantic";

export {
  fontFamily,
  fontWeight,
  headingScale,
  bodyScale,
  buttonScale,
  inputLabelScale,
} from "./typography";
export type { ResponsiveTypography } from "./typography";

export { RadiusToken, RADIUS_BASE, Shape } from "./radii";

export { designShadows } from "./shadows";

export { breakpoints } from "./breakpoints";
export type { BreakpointKey } from "./breakpoints";

export { zIndex } from "./zIndex";

export { motionDuration, motionEasing } from "./motion";
